/* KI-Kennzeichnung fuer Bilder im Artikeltext.
 *
 * Pflicht: Art. 50 Abs. 4 VO (EU) 2024/1689, seit 02.08.2026. Die Angabe muss beim
 * ersten Anblick erkennbar sein, deshalb reicht der Alt-Text allein nicht.
 *
 * Warum es diese Datei gibt: Bilder im Artikeltext stehen als rohes HTML im
 * body_html. Liquid rendert sie nicht, das Snippet ds-ki-label erreicht sie also
 * nicht. Titelbild, Produktgalerie und Hero laufen weiter ueber Liquid, hier geht
 * es nur um den Artikeltext.
 *
 * Der Ausloeser ist derselbe wie im Liquid: der Alt-Text traegt "KI-generiert",
 * oder der Dateiname endet auf "-ki.". Es gibt also keine Liste, die jemand
 * pflegen muesste, und markiert wird nur, was markiert gehoert.
 *
 * Das Badge braucht einen positionierten Elternteil. Ein Absatz taugt dafuer
 * nicht: das Badge saesse in der Ecke des Absatzes statt im Bild. Deshalb bekommt
 * jedes betroffene Bild eine eigene Huelle, und nur dieses.
 *
 * Das CSS liegt global in assets/ds-theme.css.
 */
(function () {
  'use strict';

  var MARKER = 'ki-generiert';
  var DATEI_ENDUNG = '-ki.';

  function istKi(bild) {
    var alt = (bild.getAttribute('alt') || '').toLowerCase();
    if (alt.indexOf(MARKER) !== -1) return true;
    var quelle = (bild.getAttribute('src') || '').split('?')[0].toLowerCase();
    return quelle.indexOf(DATEI_ENDUNG) !== -1;
  }

  // Traegt das Badge in einen Container, der NUR dieses Bild enthaelt (figure,
  // picture, ein Link ums Bild). Gemessen am 06.09.2026: die Fliesstext-Bilder
  // stehen bereits in <figure class="ds-image-breakout">. Eine eigene Huelle
  // waere dort nicht nur ueberfluessig, sie kann die Bildbreite brechen, weil
  // ein inline-block zwischen Block-Elternteil und einem Bild mit width:100%
  // dessen Bezugsbreite aendert. Nur wo kein solcher Container existiert, wird
  // einer gebaut.
  function traeger(bild) {
    var e = bild.parentNode;
    if (!e || !e.tagName) return null;
    var tag = e.tagName.toLowerCase();
    if (tag !== 'figure' && tag !== 'picture' && tag !== 'a' && tag !== 'div' && tag !== 'span') return null;
    // Nur wenn der Container ausser dem Bild nichts Sichtbares traegt.
    var kinder = e.children;
    for (var i = 0; i < kinder.length; i++) {
      var k = kinder[i];
      if (k === bild) continue;
      if (k.tagName.toLowerCase() === 'source') continue;      // <picture>
      if (k.classList.contains('ds-ki-label')) continue;
      return null;
    }
    return e;
  }

  function kennzeichne(bild) {
    if (bild.dataset.dsKiGeprueft) return;
    bild.dataset.dsKiGeprueft = '1';
    if (!istKi(bild)) return;

    var eltern = bild.parentNode;
    if (!eltern) return;
    if (eltern.classList && eltern.classList.contains('ds-ki-wrap')) return;

    var ziel = traeger(bild);
    if (!ziel) {
      ziel = document.createElement('span');
      ziel.className = 'ds-ki-wrap';
      ziel.style.position = 'relative';
      ziel.style.display = 'inline-block';
      ziel.style.lineHeight = '0';
      ziel.style.maxWidth = '100%';
      eltern.insertBefore(ziel, bild);
      ziel.appendChild(bild);
    }
    if (ziel.querySelector(':scope > .ds-ki-label')) return;

    var badge = document.createElement('span');
    badge.className = 'ds-ki-label';
    badge.setAttribute('aria-hidden', 'true');
    badge.textContent = 'KI-generiert';
    ziel.appendChild(badge);
  }

  function lauf() {
    var flaechen = document.querySelectorAll('.ds-rte, .rte, [data-ds-article-content]');
    for (var i = 0; i < flaechen.length; i++) {
      var bilder = flaechen[i].querySelectorAll('img');
      for (var j = 0; j < bilder.length; j++) {
        try { kennzeichne(bilder[j]); } catch (e) { /* ein Bild darf den Rest nicht stoppen */ }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lauf);
  } else {
    lauf();
  }
  // Der Artikeltext wird an den h2-Grenzen geteilt und nachtraeglich zusammengesetzt.
  // Ein zweiter Lauf nach dem Laden faengt, was dabei spaeter im DOM landet.
  window.addEventListener('load', lauf);
})();
